import { useTranslation } from "react-i18next";
export const useRequestDigitalSignature = () => {
  const { t } = useTranslation();

  return {
    t,
  };
};
